<template>
  <div class="glass2" v-if="showBestSellersDashboard">
    <h4 style="text-align: center; font-weight: bold;"> BEST SELLERS</h4>

    <!-- Best Sellers Content -->
    <div class="best-sellers-content">
      <!-- Summary Stats -->
      <!-- <div class="summary-stats" v-if="bestSellersData.length > 0">
        <div class="module-card stat-card">
          <div class="stat-header">
            <div class="stat-icon total-sales">
              <i class="fas fa-cube"></i>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ totalProductsSold }}</div>
            <div class="stat-label">Total Products Sold</div>
          </div>
        </div>

        <div class="module-card stat-card">
          <div class="stat-header">
            <div class="stat-icon orders">
              <i class="fas fa-chart-line"></i>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ filteredBestSellers.length }}</div>
            <div class="stat-label">Unique Products</div>
          </div>
        </div>

     
        <div class="module-card stat-card clickable-stat"
             @click="showTopSellerStats"
             @mouseenter="hoverStat = 'topSeller'"
             @mouseleave="hoverStat = null">
          <div class="stat-header">
            <div class="stat-icon average" :class="{ 'pulse': hoverStat === 'topSeller' }">
              <i class="fas fa-crown"></i>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ topSellerProduct.name }}</div>
            <div class="stat-label">Top Seller</div>
            <div class="stat-streak">
              <div class="stat-trend" v-if="topSellerProduct.totalSold">
                <i class="fas fa-fire"></i>
                {{ topSellerProduct.totalSold }} sold
              </div>
              <div class="stat-trend" v-if="topSellerProduct.in_stock">
                <i class="fas fa-fire"></i>
                {{ topSellerProduct.in_stock }} In Stock
              </div>
            </div>
          </div>
          <div class="stat-hover-indicator">
            <i class="fas fa-chart-bar"></i>
            Click for stats
          </div>
        </div>
      </div> -->



      <!-- Enhanced Summary View with Interactive Cards -->
      <div v-if="bestSellersViewType === 'summary' && filteredBestSellers.length > 0" class="best-sellers-summary">
        <div class="chart-card enhanced-chart">
          <div class="chart-header">
            <div class="chart-title-section">
              <h5 >TOP SELLING</h5>
              <!-- <div class="scroll-hint" v-if="filteredBestSellers.length > 3">
                <i  class="fas fa-arrows-left-right"></i>
                Scroll to see more products
              </div> -->
            </div>
            <div class="category-tabs-section" v-if="bestSellersData.length > 0">
              <div class="category-tabs-container">
                <!-- All Categories Tab -->
                <button
                  class="category-tab"
                  :class="{ 'active': selectedCategory === null }"
                  @click="selectCategory(null)"
                >
                  <span class="tab-label">All Categories</span>
                  <span class="tab-count">{{ bestSellersData.length }}</span>
                </button>

                <!-- Individual Category Tabs -->
                <button
                  v-for="category in categoryOptions"
                  :key="category.value"
                  class="category-tab"
                  :class="{ 'active': selectedCategory === category.value }"
                  @click="selectCategory(category.value)"
                >
                  <span class="tab-label">{{ category.text }}</span>
                  <span class="tab-count">{{ getCategoryProductCount(category.value) }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Horizontal Scrolling Product Cards -->
          <div class="horizontal-scroll-container" :class="{ 'scrollable': filteredBestSellers.length > 3 }">
            <!-- Navigation Buttons -->
            <div class="scroll-buttons">
              <button class="scroll-btn scroll-btn-prev" @click="scrollLeft" :disabled="!canScrollLeft">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button class="scroll-btn scroll-btn-next" @click="scrollRight" :disabled="!canScrollRight">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>

            <div class="products-grid" ref="productsGrid">
              <div v-for="(product, index) in filteredBestSellers.slice(0, 12)" :key="product.sku"
                   class="product-card"
                   :class="{
                     'top-product': index < 3,
                     'featured-product': index === 0
                   }"
                   @click="showProductStats(product)">
                <!-- Product Rank -->
                <div class="product-rank">
                  <div class="rank-badge" :class="getRankClass(index)">
                    #{{ index + 1 }}
                  </div>
                  <div class="product-actions">
                    <b-button variant="outline-primary" size="sm" @click.stop="quickViewProduct(product)">
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </div>
                  <div style="color:black" class="product-trend" v-if="product.trend">
                    <i style="color:black" :class="getTrendIcon(product.trend)"></i>
                  </div>
                  <div class="product-trend" v-if="product.profit_margin">
                    <i :class="getProfitMarginIcon(product.profit_margin)"></i>
                    {{ product.profit_margin }}%
                  </div>
                </div>
                  <div class="product-image-section">
                    <div v-if="getProductImage(product)" class="image-container" @click.stop="showFullImage(product)">
                      <img 
                        :src="getProductImage(product)" 
                        :alt="product.product_name || product.sku"
                        class="product-image"
                        @error="handleImageError($event, product)"
                        @load="handleImageLoad($event, product)"
                      />
                      <div class="image-overlay">
                        🔍
                      </div>
                    </div>
                    <div v-else class="no-image-placeholder">
                      <div class="placeholder-icon">📷</div>
                      <div class="placeholder-text">No Image</div>
                    </div>
                  </div>

                <div class="product-info">
                  <h6 class="product-name">{{ product.product_name }}</h6>
                  <div class="product-sku">
                    <b-badge variant="outline-secondary">{{ product.sku }}</b-badge>
                  </div>
                  <div class="product-category" v-if="product.category_name">
                    {{ product.category_name }}
                  </div>
                </div>

                <div class="product-stats">
                  <div class="stat-item">
                    <span class="stat-label">In Stock</span>
                    <span class="stat-value">{{ product.in_stock || product.in_stock || 0 }}</span>

                    <span class="stat-label">Total Sold</span>
                    <span class="stat-value">{{ product.sold_so_far || product.total_sold || 0 }}</span>
                  </div>
                  <div class="stat-breakdown">
                    <div class="breakdown-item">
                      <span>7D:</span>
                      <strong>{{ product.sold_7d || 0 }}</strong>
                    </div>
                    <div class="breakdown-item">
                      <span>30D:</span>
                      <strong>{{ product.sold_30d || 0 }}</strong>
                    </div>
                    <div class="breakdown-item">
                      <span>90D:</span>
                      <strong>{{ product.sold_90d || 0 }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Enhanced Detailed View -->
      <div v-if="bestSellersViewType === 'detailed' && filteredBestSellers.length > 0" class="best-sellers-detailed">
        <div class="chart-card enhanced-chart">
          <div class="chart-header">
            <h5>Sales by Product & Salesperson</h5>
            <b-badge variant="info">{{ filteredBestSellers.length }} Records</b-badge>
          </div>

          <div class="detailed-table">
            <div class="table-header">
              <div class="table-row header-row">
                <div class="table-cell">Product</div>
                <div class="table-cell">SKU</div>
                <div class="table-cell">Category</div>
                <div class="table-cell">Location</div>
                <div class="table-cell">Salesperson</div>
                <div class="table-cell">Total Sold</div>
                <div class="table-cell">Total In-Stock</div>
                <div class="table-cell">7 Days</div>
                <div class="table-cell">30 Days</div>
                <div class="table-cell">Actions</div>
              </div>
            </div>

            <div class="table-body">
              <div v-for="item in filteredBestSellers.slice(0, 20)" :key="`${item.location_id}-${item.salesperson}-${item.sku}`"
                   class="table-row detailed-row clickable-row"
                   @click="showProductStats(item)">
                <div class="table-cell product-name">
                  {{ item.product_name }}
                </div>
                <div class="table-cell product-sku">
                  {{ item.sku }}
                </div>
                <div class="table-cell product-category">
                  {{ item.category_name || 'N/A' }}
                </div>
                <div class="table-cell location-name">
                  {{ item.location_name || 'N/A' }}
                </div>
                <div class="table-cell salesperson">
                  {{ item.salesperson || 'N/A' }}
                </div>
                <div class="table-cell total-sold">
                  <strong>{{ item.total_sold || 0 }}</strong>
                </div>
                <div class="table-cell total-instock">
                  <strong>{{ item.in_stock || 0 }}</strong>
                </div>
                <div class="table-cell sold-7d">
                  {{ item.sold_7d || 0 }}
                </div>
                <div class="table-cell sold-30d">
                  {{ item.sold_30d || 0 }}
                </div>
                <div class="table-cell actions">
                  <b-button variant="outline-primary" size="sm" @click.stop="showProductStats(item)">
                    <i class="fas fa-chart-bar"></i>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="bestSellersLoading" class="loading-state">
        <div class="spinner"></div>
        <p>Loading best sellers data...</p>
      </div>

      <!-- Empty State -->
      <div v-if="!bestSellersLoading && filteredBestSellers.length === 0" class="empty-dashboard">
        <div class="empty-icon">
          <i class="fas fa-box-open" v-if="selectedCategory"></i>
          <i class="fas fa-chart-bar" v-else></i>
        </div>
        <h3 v-if="selectedCategory">No Products in This Category</h3>
        <h3 v-else>No Best Sellers Data</h3>
        <p v-if="selectedCategory">No products found in the selected category</p>
        <p v-else>Select filters and click apply to load best sellers data</p>
        <b-button variant="primary" @click="fetchBestSellersData" v-if="!selectedCategory">
          Load Data
        </b-button>
        <b-button variant="outline-primary" @click="selectCategory(null)" v-else>
          Show All Categories
        </b-button>
      </div>
    </div>

    <!-- Product Stats Modal -->
    <b-modal v-model="showProductStatsModal"
             :title="selectedProduct ? selectedProduct.product_name : 'Product Stats'"
             size="xl"
             hide-footer
             centered
             class="product-stats-modal"
             header-class="product-modal-header"
             body-class="product-modal-body">

      <div v-if="selectedProduct" class="product-stats-content">
        <!-- Tabs Navigation -->
        <b-card no-body class="mt-3">
          <b-tabs  card v-model="activeTab">
            <!-- Summary Tab -->
            <b-tab  title="SUMMARY" active>
              <b-card-text>
                <!-- Sales Statistics -->
                <div class="stats-grid">
                  <div sclass="stat-card">
                    <div class="stat-icon total-sales">
                      <i class="fas fa-shopping-cart"></i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">{{ selectedProduct.sold_so_far || selectedProduct.total_sold || 0 }}</div>
                      <div class="stat-label">Total Sold</div>
                    </div>
                  </div>

                  <div class="stat-card">
                    <div class="stat-icon sales-7d">
                      <i class="fas fa-calendar-week"></i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">{{ selectedProduct.sold_7d || 0 }}</div>
                      <div class="stat-label">Last 7 Days</div>
                    </div>
                  </div>

                  <div class="stat-card">
                    <div class="stat-icon sales-30d">
                      <i class="fas fa-calendar-alt"></i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">{{ selectedProduct.sold_30d || 0 }}</div>
                      <div class="stat-label">Last 30 Days</div>
                    </div>
                  </div>

                  <div class="stat-card">
                    <div class="stat-icon sales-90d">
                      <i class="fas fa-calendar"></i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">{{ selectedProduct.sold_90d || 0 }}</div>
                      <div class="stat-label">Last 90 Days</div>
                    </div>
                  </div>

                  <div class="stat-card">
                    <div class="stat-icon orders">
                      <i class="fas fa-chart-line"></i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">{{ selectedProduct.in_stock || selectedProduct.in_stock || 0 }}</div>
                      <div class="stat-label">Total In Stock</div>
                    </div>
                  </div>
                </div>

                <!-- Quick Actions -->
                <div class="quick-actions mt-4">
                  <b-button  variant="outline-primary" size="sm" @click="activeTab = 1">
                    <i  class="fas fa-search"></i> View Detailed Analysis
                  </b-button>
                  <b-button variant="outline-primary" size="sm" @click="activeTab = 2">
                    <i class="fas fa-receipt"></i> View Price Details
                  </b-button>
                </div>
              </b-card-text>
            </b-tab>

            <!-- Detailed View Tab -->
            <b-tab  title="DETAILS">
  <b-card-text>
    <!-- Detailed View Content -->
    <div class="detailed-view-content">
      <!-- Summary Stats -->
      <b-card class="mb-3">
        <b-row >
          <b-col>
            <strong>Total Locations:</strong> {{ getUniqueLocations }}
          </b-col>
          <b-col>
            <strong>Total Salespeople:</strong> {{ getUniqueSalespeople }}
          </b-col>
          <b-col>
            <strong>Total Units Sold:</strong> {{ getDetailedTotalSold }}
          </b-col>
        </b-row>
      </b-card>

      <!-- Location-wise Data Table -->
      <div class="table-scroll-container detailed-table-container"  v-if="locationWiseData.length > 0">
        <b-table sstriped hover
                :items="locationWiseData"
                :fields="locationFields"
                small
                class="detailed-table">
          <template #cell(location_name)="data">
            <b-button
              variant="link"
              class="p-0 location-link"
              @click="showSalespersonModal(data.item)">
              <strong>{{ data.value || 'N/A' }}</strong>
            </b-button>
          </template>
          <template #cell(total_sold)="data">
            <strong>{{ data.value || 0 }}</strong>
          </template>
          <template #cell(sold_7d)="data">
            {{ data.value || 0 }}
          </template>
          <template #cell(sold_30d)="data">
            {{ data.value || 0 }}
          </template>
          <template #cell(sold_90d)="data">
            {{ data.value || 0 }}
          </template>
          <template #cell(actions)="data">
            <b-button
              variant="outline-primary"
              size="sm"
              @click="showSalespersonModal(data.item)">
              <i class="fas fa-users"></i> View Salespeople
            </b-button>
          </template>
        </b-table>
      </div>

      <div  v-else class="text-center py-4">
        <b-alert variant="warning" show>
          <i class="fas fa-exclamation-triangle"></i>
          No location data available
        </b-alert>
      </div>
    </div>
  </b-card-text>
</b-tab>

            <!-- Price Details Tab -->
            <b-tab title="PRICE DETAILS">
              <b-card-text>
                <!-- Price Details Content -->
                <div class="price-details-content">
                  <!-- Filters -->
                  <b-card class="mb-3">
                    <b-row  class="filters-row align-items-end">
                      <b-col md="3">
                        <label  class="small mb-1"><strong>DATE RANGE</strong></label></br>
                        <date-picker
                          v-model="soldDateRange"
                          type="date"
                          range
                          placeholder="Select date range"
                          value-type="YYYY-MM-DD"
                          format="MMM DD, YYYY"
                          style=" width:200px !important;"
                          @input="applySoldDetailsFilters"
                          class="mb-2">
                        </date-picker>
                      </b-col>

                      <b-col  md="3">
                        <label  class="small mb-1"><strong>LOCATION</strong></label>
                        <b-form-select
                          :options="soldLocationOptions"
                          v-model="soldLocationFilter"
                          @change="applySoldDetailsFilters"
                          class="mb-2">
                        </b-form-select>
                      </b-col>

                      <b-col  md="3">
                        <label  class="small mb-1"><strong>SALESPERSON</strong></label>
                        <b-form-select
                          :options="soldSalespersonOptions"
                          v-model="soldSalespersonFilter"
                          @change="applySoldDetailsFilters"

                          class="mb-2">
                        </b-form-select>
                      </b-col>

                      <b-col md="3">
                        <label class="small mb-1"><strong>INVOICE NUMBER</strong></label>
                        <b-form-input
                          v-model="soldInvoiceFilter"
                          placeholder="Search invoice"
                          @input="applySoldDetailsFilters"
                          debounce="300"
                          class="mb-2">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row v-if="hasActiveSoldDetailsFilters" class="mt-2">
                      <b-col >
                        <small class="text-muted">
                          Showing {{ filteredSoldDetails.length }} of {{ soldDetails.length }} transactions
                        </small>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="clearSoldDetailsFilters"
                          class="ml-2">
                          <i class="fas fa-times"></i> Clear Filters
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>

                  <!-- Sold Details Table -->
                  <div class="table-scroll-container sold-details-table-container"  v-if="filteredSoldDetails.length > 0">
                    <b-table striped hover
                            :items="filteredSoldDetails"
                            :fields="soldDetailsFields"
                            small
                            class="sold-details-table">
                      <template #cell(sold_date)="data">
                        {{ formatDate(data.value) }}
                      </template>
                      <template #cell(invoice_number)="data">
                        <a :href="`#/sales/viewsale/${data.value}/`"
                           target="_blank"
                           class="invoice-link"
                           @click.stop>
                          {{ data.value }}
                        </a>
                      </template>
                      <template #cell(price)="data">
                        ${{ data.value.toFixed(2) }}
                      </template>
                      <template #cell(sold_price)="data">
                        ${{ data.value.toFixed(2) }}
                      </template>
                      <template #cell(discount)="data">
                        {{ data.value }}%
                      </template>
                      <template #cell(profit_margin)="data">
                        {{ data.value }}%
                      </template>
                    </b-table>
                  </div>

                  <div  v-else class="text-center py-4">
                    <b-alert variant="info" show>
                      <i class="fas fa-info-circle"></i>
                      No individual sales transactions found
                      <span v-if="hasActiveSoldDetailsFilters"> matching your filters</span>
                    </b-alert>
                  </div>

                  <b-card  class="mb-3">
                    <b-row >
                      <b-col >
                        <strong>Total Transactions:</strong> {{ filteredSoldDetails.length }}
                      </b-col>
                      <b-col>
                        <strong>Total Revenue:</strong> ${{ getTotalRevenue.toFixed(2) }}
                      </b-col>
                      <b-col >
                        <strong>Average Sold Price:</strong> ${{ getAverageSoldPrice.toFixed(2) }}
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>

        <!-- Modal Actions -->
        <div class="modal-actions">
          <b-button variant="outline-secondary" @click="showProductStatsModal = false">
            Close
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-image-viewer-best-sellers" size="lg" hide-footer centered title="Product Image">
    <div class="text-center">
        <b-img 
            :src="currentFullSizeImage" 
            fluid 
            alt="Full size product image"
            style="max-height: 70vh; object-fit: contain;"
        />
        <div class="mt-3">
            <strong>{{ currentProductName }}</strong>
        </div>
    </div>
    <template #modal-footer>
        <b-button size="sm" variant="secondary" @click="$bvModal.hide('modal-image-viewer-best-sellers')">
            Close
        </b-button>
    </template>
</b-modal>

    <!-- Top Seller Stats Modal -->
    <b-modal v-model="showTopSellerModal"
             title="Top Seller Performance"
             size="lg"
             hide-footer
             centered
             class="top-seller-modal">

      <div v-if="topSellerProduct" class="top-seller-content">
        <div class="top-seller-header">
          <div class="crown-icon">
            <i class="fas fa-crown"></i>
          </div>
          <h4>{{ topSellerProduct.name }}</h4>
          <b-badge variant="warning">Top Performer</b-badge>
        </div>

        <div class="performance-stats">
          <div class="performance-metric">
            <div class="metric-value">{{ topSellerProduct.totalSold }}</div>
            <div class="metric-label">Total Units Sold</div>
          </div>
          <div class="performance-metric">
            <div class="metric-value">{{ topSellerProduct.in_stock }}</div>
            <div class="metric-label">Total In Stock</div>
          </div>
          <div class="performance-metric">
            <div class="metric-value">{{ topSellerProduct.averageProfitMargin || '25%' }}%</div>
            <div class="metric-label">Average Profit Margin</div>
          </div>
          <div class="performance-metric">
            <div class="metric-value">${{ formatPrice(topSellerProduct.totalRevenue || 0) }}</div>
            <div class="metric-label">Total Revenue</div>
          </div>
        </div>

        <div class="modal-actions">
          <b-button  @click="showProductStats(topSellerProduct)">
            View Detailed Stats
          </b-button>
          <b-button  @click="showTopSellerModal = false">
            Close
          </b-button>
        </div>
      </div>
    </b-modal>
<b-modal v-model="salespersonModalVisible"
         :title="`Salespeople - ${selectedLocation ? selectedLocation.location_name : 'Location'}`"
         size="lg"
         hide-footer
         centered
         class="salesperson-modal"
         header-class="salesperson-modal-header"
         body-class="salesperson-modal-body">

  <div v-if="selectedLocation" class="salesperson-content">
    <!-- Location Summary -->
    <b-card class="mb-3">
      <b-row >
        <b-col>
          <strong>Location:</strong> {{ selectedLocation.location_name }}
        </b-col>
        <b-col>
          <strong>Total Sold:</strong> {{ selectedLocation.total_sold || 0 }}
        </b-col>
        <b-col>
          <strong>Salespeople:</strong> {{ salespersonData.length }}
        </b-col>
      </b-row>
    </b-card>

    <!-- Salesperson Table -->
    <div class="table-scroll-container salesperson-table-container" v-if="salespersonData.length > 0">
      <b-table striped hover
              :items="salespersonData"
              :fields="salespersonFields"
              small
              class="salesperson-table">
        <template #cell(salesperson)="data">
          <b-badge variant="outline-primary">{{ data.value || 'N/A' }}</b-badge>
        </template>
        <template #cell(total_sold)="data">
          <strong>{{ data.value || 0 }}</strong>
        </template>
      </b-table>
    </div>

    <div v-else class="text-center py-4">
      <b-alert variant="info" show>
        <i class="fas fa-info-circle"></i>
        No salesperson data available for this location
      </b-alert>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions mt-3">
       <b-button variant="outline-secondary" @click="salespersonModalVisible = false">
        Close
      </b-button>
    </div>
  </div>
</b-modal>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import Requestor from '@/utilities/Requestor';

export default {
  name: "BestSellersDashboard",
  components: {
    DatePicker
  },
  props: {
    userDetails: {
      type: Object,
      default: () => ({})
    },
    showBestSellersDashboard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bestSellersData: [],
       currentFullSizeImage: null,
        currentProductName: null,
      salespersonModalVisible: false,
    selectedLocation: null,
    salespersonData: [],
      bestSellersLoading: false,
      bestSellersDateRange: [moment().subtract(30, 'days').format("MM-DD-YYYY"), moment().format("MM-DD-YYYY")],
      bestSellersPickedLocation: null,
      bestSellersPickedUser: null,
      bestSellersViewType: 'summary',
      bestSellersFilterDropdownOpen: false,
      showAllProducts: false,
      showProductStatsModal: false,
      showTopSellerModal: false,
      selectedProduct: null,
      hoverStat: null,
      activeTab: 0,
      touchStartX: 0,
      touchEndX: 0,
      detailedItems: [],
      detailedDateRange: 'all_time',
      detailedLocationId: null,
      detailedLocationOptions: [],
      soldDetails: [],
      soldDateRange: [],
      soldLocationFilter: null,
      soldSalespersonFilter: null,
      soldInvoiceFilter: '',
      soldLocationOptions: [],
      soldSalespersonOptions: [],

      // Category Tabs Data
      selectedCategory: null,
      categoryOptions: [],
      locationFields: [
      {
        key: 'location_name',
        label: 'STORE LOCATION',
        sortable: true,
        thStyle: { width: '200px' }
      },
      { key: 'sold_7d', label: '7 DAYS', sortable: true },
      { key: 'sold_30d', label: '30 DAYS', sortable: true },
      { key: 'sold_90d', label: '90 DAYS', sortable: true },
      { key: 'total_sold', label: 'TOTAL SOLD', sortable: true },
      {
        key: 'actions',
        label: 'ACTIONS',
        thStyle: { width: '150px' }
      }
    ],

    salespersonFields: [
      {
        key: 'salesperson',
        label: 'SALESPERSON',
        sortable: true,
        thStyle: { width: '200px' }
      },
      { key: 'sold_7d', label: '7 DAYS', sortable: true },
      { key: 'sold_30d', label: '30 DAYS', sortable: true },
      { key: 'sold_90d', label: '90 DAYS', sortable: true },
      { key: 'total_sold', label: 'TOTAL SOLD', sortable: true }
    ],

      detailedFields: [
        {
          key: 'location_name',
          label: 'STORE LOCATION',
          sortable: true,
          thStyle: { width: '180px' }
        },
        {
          key: 'salesperson',
          label: 'SALESPERSON',
          sortable: true,
          thStyle: { width: '150px' }
        },
        { key: 'sold_7d', label: '7 DAYS', sortable: true },
        { key: 'sold_30d', label: '30 DAYS', sortable: true },
        { key: 'sold_60d', label: '60 DAYS', sortable: true },
        { key: 'sold_90d', label: '90 DAYS', sortable: true },
        { key: 'sold_120d', label: '120 DAYS', sortable: true },
        { key: 'total_sold', label: 'TOTAL SOLD', sortable: true }
      ],

      scrollPosition: 0,
      maxScroll: 0,
      canScrollLeft: false,
      canScrollRight: true,

      soldDetailsFields: [
        {
          key: 'sold_date',
          label: 'SOLD DATE',
          sortable: true,
          thStyle: { width: '120px' }
        },
        {
          key: 'store_location',
          label: 'STORE LOCATION',
          sortable: true,
          thStyle: { width: '150px' }
        },
        {
          key: 'invoice_number',
          label: 'INVOICE#',
          sortable: true,
          thStyle: { width: '130px' }
        },
        {
          key: 'salesperson_name',
          label: 'SALESPERSON',
          sortable: true,
          thStyle: { width: '140px' }
        },
        {
          key: 'price',
          label: 'PRICE',
          sortable: true,
          thStyle: { width: '100px' },
          tdClass: 'text-left'
        },
        {
          key: 'sold_price',
          label: 'SOLD PRICE',
          sortable: true,
          thStyle: { width: '110px' },
          tdClass: 'text-left'
        },
        {
          key: 'profit_margin',
          label: 'PROFIT %',
          sortable: true,
          thStyle: { width: '120px' },
          tdClass: (value, key, item) => this.getProfitMarginClass(item.profit_margin),
        },
        {
          key: 'discount',
          label: 'DISCOUNT',
          sortable: true,
          thStyle: { width: '100px' },
          tdClass: 'text-left'
        }
      ],

      dateRangeOptions: [
        { value: '7_days', text: 'LAST 7 DAYS' },
        { value: '30_days', text: 'LAST 30 DAYS' },
        { value: '60_days', text: 'LAST 60 DAYS' },
        { value: '90_days', text: 'LAST 90 DAYS' },
        { value: '120_days', text: 'LAST 120 DAYS' },
        { value: 'all_time', text: 'ALL TIME' }
      ],

      // Location Map
      locationMap: {
        16: "HUNTING PARK",
        44: "ONLINE SALES",
        29: "LANCASTER",
        25: "ALLENTOWN",
        27: "READING",
        28: "EWING",
        22: "LANSDOWNE",
        17: "UPPER DARBY",
        46: "OUT OF STOCK",
        40: "9TH ST",
        36: "VENANGO",
        24: "DELMAR",
        47: "MECCA SHIPPING",
        42: "101 WH",
        41: "FOLCROFT"
      }
    }
  },
  computed: {
     locationWiseData() {
    const locationMap = new Map();

    this.detailedItems.forEach(item => {
      const locationId = item.location_id;
      const locationName = item.location_name || 'Unknown Location';

      if (!locationMap.has(locationId)) {
        locationMap.set(locationId, {
          location_id: locationId,
          location_name: locationName,
          sold_7d: 0,
          sold_30d: 0,
          sold_90d: 0,
          total_sold: 0
        });
      }

      const locationData = locationMap.get(locationId);
      locationData.sold_7d += item.sold_7d || 0;
      locationData.sold_30d += item.sold_30d || 0;
      locationData.sold_90d += item.sold_90d || 0;
      locationData.total_sold += item.total_sold || 0;
    });

    return Array.from(locationMap.values()).sort((a, b) => b.total_sold - a.total_sold);
  },
    // Filter products by selected category
    filteredBestSellers() {
      if (!this.selectedCategory) {
        return this.bestSellersData;
      }
      return this.bestSellersData.filter(product =>
        product.category_id === this.selectedCategory
      );
    },

    // Get unique categories from data
    uniqueCategories() {
      const categories = new Map();
      this.bestSellersData.forEach(product => {
        if (product.category_id && product.category_name) {
          categories.set(product.category_id, {
            value: product.category_id,
            text: product.category_name
          });
        }
      });
      return Array.from(categories.values());
    },

    // Get product count for a category
    getCategoryProductCount() {
      return (categoryId) => {
        if (!categoryId) return this.bestSellersData.length;
        return this.bestSellersData.filter(product =>
          product.category_id === categoryId
        ).length;
      };
    },

    averageProfitMargin() {
      if (!this.filteredBestSellers.length) return 0;

      const allMargins = this.filteredBestSellers.map(product =>
        product.average_profit_margin || this.calculateAverageProfitMargin(product)
      ).filter(margin => margin > 0);

      if (!allMargins.length) return 0;

      const average = allMargins.reduce((sum, margin) => sum + margin, 0) / allMargins.length;
      return Math.round(average * 100) / 100;
    },

    totalRevenue() {
      if (!this.filteredBestSellers.length) return 0;

      return this.filteredBestSellers.reduce((total, product) => {
        return total + (product.total_selling_price || this.calculateTotalSellingPrice(product));
      }, 0);
    },

    getDetailedTotalSold() {
      return this.detailedItems.reduce((sum, item) => sum + (item.total_sold || 0), 0);
    },

    getUniqueLocations() {
      const locations = new Set(this.detailedItems.map(item => item.location_name).filter(Boolean));
      return locations.size;
    },

    getUniqueSalespeople() {
      const salespeople = new Set(this.detailedItems.map(item => item.salesperson).filter(Boolean));
      return salespeople.size;
    },

    // Price Details Computed
    getTotalRevenue() {
      return this.filteredSoldDetails.reduce((sum, item) => sum + (item.sold_price || 0), 0);
    },

    getAverageSoldPrice() {
      return this.filteredSoldDetails.length > 0
        ? this.getTotalRevenue / this.filteredSoldDetails.length
        : 0;
    },

    filteredSoldDetails() {
      let items = this.soldDetails;

      // Filter by date range
      if (this.soldDateRange && this.soldDateRange.length === 2) {
        const startDate = moment(this.soldDateRange[0]);
        const endDate = moment(this.soldDateRange[1]);

        items = items.filter(item => {
          const soldDate = moment(item.sold_date);
          return soldDate.isBetween(startDate, endDate, 'day', '[]');
        });
      }

      // Filter by location
      if (this.soldLocationFilter) {
        items = items.filter(item =>
          item.store_location_id == this.soldLocationFilter
        );
      }

      // Filter by salesperson
      if (this.soldSalespersonFilter) {
        items = items.filter(item =>
          item.salesperson_id == this.soldSalespersonFilter
        );
      }

      // Filter by invoice number
      if (this.soldInvoiceFilter) {
        const query = this.soldInvoiceFilter.toLowerCase().trim();
        items = items.filter(item =>
          item.invoice_number.toLowerCase().includes(query)
        );
      }

      // Calculate profit margin for each item
      items = items.map(item => ({
        ...item,
        profit_margin: this.calculateProfitMargin(item)
      }));

      return items;
    },

    hasActiveSoldDetailsFilters() {
      return (this.soldDateRange && this.soldDateRange.length === 2) ||
             this.soldLocationFilter !== null ||
             this.soldSalespersonFilter !== null ||
             this.soldInvoiceFilter !== '';
    },

    bestSellersLocationOptions() {
      return Object.entries(this.locationMap).map(([id, name]) => ({
        value: parseInt(id),
        text: name
      })).sort((a, b) => a.text.localeCompare(b.text));
    },

    bestSellersUserOptions() {
      if (!this.bestSellersData.length) return [];
      const uniqueUsers = [...new Set(this.bestSellersData.map(item => item.salesperson || item.salesperson_name).filter(Boolean))];
      return uniqueUsers.map(username => ({
        value: username,
        text: username
      })).sort((a, b) => a.text.localeCompare(b.text));
    },

    hasBestSellersActiveFilters() {
      return this.bestSellersPickedLocation !== null || this.bestSellersPickedUser !== null;
    },

    totalProductsSold() {
      if (!this.filteredBestSellers.length) return 0;
      return this.filteredBestSellers.reduce((total, item) => {
        return total + (item.sold_so_far || item.total_sold || item.quantity || 0);
      }, 0);
    },

    topSellerProduct() {
      const data = this.selectedCategory ?
        this.bestSellersData.filter(p => p.category_id === this.selectedCategory) :
        this.bestSellersData;

      if (!data.length) return {
        name: 'N/A',
        totalSold: 0,
        averageProfitMargin: 0,
        totalRevenue: 0
      };

      const topProduct = data.reduce((top, current, index) => {
        const currentSold = current.sold_so_far || current.total_sold || 0;
        const topSold = top.sold_so_far || top.total_sold || 0;
        if (currentSold > topSold) {
          return { ...current, rank: index + 1 };
        }
        return top;
      }, { ...data[0], rank: 1 });

      const totalRevenue = topProduct.total_revenue ||
                          topProduct.revenue_in_range ||
                          topProduct.revenue_30d ||
                          0;

      const averageProfitMargin = topProduct.average_profit_margin ||
                                 this.calculateAverageProfitMargin(topProduct);

      return {
        name: topProduct.product_name || 'N/A',
        totalSold: topProduct.sold_so_far || topProduct.total_sold || 0,
        averageProfitMargin: averageProfitMargin,
        totalRevenue: totalRevenue,
        in_stock: topProduct.in_stock || 0,
        ...topProduct
      };
    },
  },
  methods: {
        getProductImage(product) {
        if (!product || !product.image_url) {
            return null;
        }
        
        let imageUrl = product.image_url.trim();
        
        // Check if URL is valid
        if (imageUrl === '' || imageUrl === 'null' || imageUrl === 'undefined') {
            return null;
        }
        
        // Fix common URL issues and add CORS proxy for images from fmapi
        if (imageUrl && imageUrl.includes('fmapi.myfurnituremecca.com')) {
            // Use CORS proxy to avoid ORB blocking
            const proxyUrl = `/api/image/image-proxy/?url=${encodeURIComponent(imageUrl)}`;
            return proxyUrl;
        }
        
        return imageUrl;
    },

    handleImageError(event, product) {
        console.warn(`Image failed to load for ${product.sku}:`, event.target.src);
        
        const parent = event.target.parentElement;
        if (parent) {
            const existingFallback = parent.querySelector('.no-image-placeholder');
            if (!existingFallback) {
                parent.innerHTML = `
                    <div class="no-image-placeholder">
                        <div class="placeholder-icon">📷</div>
                        <div class="placeholder-text">No Image</div>
                    </div>
                `;
            }
        }
        event.target.style.display = 'none';
    },

    handleImageLoad(event, product) {
        console.log(`Image loaded successfully for ${product.sku}`);
    },

    showFullImage(product) {
        if (!product) return;
        
        const imageUrl = this.getProductImage(product);
        if (imageUrl) {
            this.$bvModal.show('modal-image-viewer-best-sellers');
            this.$nextTick(() => {
                this.currentFullSizeImage = imageUrl;
                this.currentProductName = product.product_name || product.sku || 'Product Image';
            });
        } else {
            this.$bvToast.toast(
                "No image available for this product",
                {title: "Info", autoHideDelay: 2000, variant:"info"}
            );
        }
    },
    showSalespersonModal(location) {
    // Validate input
    if (!location || !location.location_id) {
      console.error('Invalid location data provided to showSalespersonModal:', location);
      this.$bvToast.toast('Invalid location data', {
        variant: 'warning',
        title: 'Error'
      });
      return;
    }

    console.log('Opening salesperson modal for location:', location.location_name);

    // Set the selected location
    this.selectedLocation = { ...location };

    // Get salesperson data
    this.salespersonData = this.getSalespersonDataForLocation(location.location_id);

    // Show the modal - FIXED: Use the renamed property
    this.salespersonModalVisible = true;

    console.log('Salesperson data loaded:', this.salespersonData.length, 'records');
  },

  getSalespersonDataForLocation(locationId) {
    if (!this.detailedItems || this.detailedItems.length === 0) {
      console.warn('No detailed items available for location:', locationId);
      return [];
    }

    const salespersonMap = new Map();

    this.detailedItems
      .filter(item => item.location_id === locationId)
      .forEach(item => {
        const salesperson = item.salesperson || 'Unknown Salesperson';

        if (!salespersonMap.has(salesperson)) {
          salespersonMap.set(salesperson, {
            salesperson: salesperson,
            sold_7d: 0,
            sold_30d: 0,
            sold_90d: 0,
            total_sold: 0
          });
        }

        const salespersonData = salespersonMap.get(salesperson);
        salespersonData.sold_7d += item.sold_7d || 0;
        salespersonData.sold_30d += item.sold_30d || 0;
        salespersonData.sold_90d += item.sold_90d || 0;
        salespersonData.total_sold += item.total_sold || 0;
      });

    const result = Array.from(salespersonMap.values()).sort((a, b) => b.total_sold - a.total_sold);
    console.log(`Found ${result.length} salespeople for location ${locationId}`);
    return result;
  },
    // Category selection method
    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
    },

    // Extract categories from data
    extractCategories() {
      const categoriesMap = new Map();

      this.bestSellersData.forEach(product => {
        if (product.category_id && product.category_name) {
          categoriesMap.set(product.category_id, {
            value: product.category_id,
            text: product.category_name
          });
        }
      });

      this.categoryOptions = Array.from(categoriesMap.values())
        .sort((a, b) => a.text.localeCompare(b.text));
    },

    scrollLeft() {
      const grid = this.$refs.productsGrid;
      if (grid) {
        const cardWidth = this.getCardWidth();
        const scrollAmount = cardWidth * 2;
        const newPosition = Math.max(0, this.scrollPosition - scrollAmount);

        grid.scrollTo({
          left: newPosition,
          behavior: 'smooth'
        });

        setTimeout(() => {
          this.updateScrollButtons();
        }, 300);
      }
    },

    scrollRight() {
      const grid = this.$refs.productsGrid;
      if (grid) {
        const cardWidth = this.getCardWidth();
        const scrollAmount = cardWidth * 2;
        const newPosition = this.scrollPosition + scrollAmount;

        grid.scrollTo({
          left: newPosition,
          behavior: 'smooth'
        });

        setTimeout(() => {
          this.updateScrollButtons();
        }, 300);
      }
    },

    getCardWidth() {
      const grid = this.$refs.productsGrid;
      if (grid && grid.children.length > 0) {
        const firstCard = grid.children[0];
        const cardStyle = window.getComputedStyle(firstCard);
        const gapStyle = window.getComputedStyle(grid);

        const cardWidth = firstCard.offsetWidth;
        const gap = parseInt(gapStyle.gap) || 16;

        return cardWidth + gap;
      }
      return 320;
    },

    updateScrollButtons() {
      const grid = this.$refs.productsGrid;
      if (grid) {
        this.scrollPosition = grid.scrollLeft;
        this.maxScroll = grid.scrollWidth - grid.clientWidth;

        this.canScrollLeft = this.scrollPosition > 10;
        this.canScrollRight = this.scrollPosition < this.maxScroll - 10;
      }
    },

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    },

    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
    },

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      const swipeThreshold = 50;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0 && this.canScrollRight) {
          this.scrollRight();
        } else if (diff < 0 && this.canScrollLeft) {
          this.scrollLeft();
        }
      }
    },

    fetchTopSellerRevenue(product) {
      if (!product || !product.sku) return;

      let that = this;
      let path = "/api/product/get_selling_history/";
      let data = {
        product_sku: product.sku,
        view_type: 'revenue_summary'
      };

      let s = function(response) {
        if (response.data.result && response.data.result.revenue) {
          that.$set(that.topSellerProduct, 'totalRevenue', response.data.result.revenue);
        }
      };

      let f = function(error) {
        console.log('Error fetching top seller revenue:', error);
      };

      Requestor.getSyncP(path, data, this, s, f);
    },

    calculateTotalRevenue(product) {
      if (!this.soldDetails.length) return 0;

      const productSales = this.soldDetails.filter(item => item.sku === product.sku);

      return productSales.reduce((total, sale) => {
        return total + (sale.sold_price || 0);
      }, 0);
    },

    getProfitMarginIcon(margin) {
      if (margin > 20) return 'fas fa-arrow-up profit-high';
      if (margin > 10) return 'fas fa-minus profit-medium';
      return 'fas fa-arrow-down profit-low';
    },

    calculateProfitMargin(item) {
      const landedCost = item.landed_cost || item.cost_price || 0;
      const soldPrice = item.sold_price || 0;

      if (!landedCost || !soldPrice || landedCost === 0) {
        return 0;
      }

      const profitMargin = ((soldPrice - landedCost) / soldPrice) * 100;
      return Math.round(profitMargin * 100) / 100;
    },

    formatPrice(price) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);
    },

    getProfitMarginClass(margin) {
      if (margin > 20) return 'profit-high';
      if (margin > 10) return 'profit-medium';
      if (margin > 0) return 'profit-low';
      return 'profit-negative';
    },

    showTopSellerStats() {
      this.showTopSellerModal = true;
    },

    quickViewProduct(product) {
      this.showProductStats(product);
    },

    showProductStats(product) {
      this.selectedProduct = {
        ...product,
        rank: this.filteredBestSellers.findIndex(p => p.sku === product.sku) + 1
      };
      this.showProductStatsModal = true;
      this.activeTab = 0;

      this.clearDetailedFilters();
      this.clearSoldDetailsFilters();
      this.fetchDetailedData();
      this.fetchSoldDetails();
    },

    exportProductData(product) {
      console.log('Exporting product data:', product);
      this.$bvToast.toast(`Exporting data for ${product.product_name}`, {
        variant: 'info',
        title: 'Export'
      });
    },

    getRankClass(index) {
      if (index === 0) return 'rank-gold';
      if (index === 1) return 'rank-silver';
      if (index === 2) return 'rank-bronze';
      return 'rank-other';
    },

    getRankBadgeVariant(index) {
      if (index < 3) return 'warning';
      if (index < 10) return 'info';
      return 'secondary';
    },

    getTrendIcon(trend) {
      if (!trend) return 'fas fa-minus';
      return trend > 0 ? 'fas fa-arrow-up trend-positive' : 'fas fa-arrow-down trend-negative';
    },

    getTrendClass(trend) {
      if (!trend) return '';
      return trend > 0 ? 'trend-positive' : 'trend-negative';
    },

    fetchDetailedData() {
      if (!this.selectedProduct) return;

      let that = this;
      let path = "/api/product/get_selling_history/";
      let data = {
        date_range: this.detailedDateRange,
        location_id: this.detailedLocationId,
        product_sku: this.selectedProduct.sku,
        view_type: 'detailed'
      };

      let s = function(response) {
        if (response.data.result) {
          that.detailedItems = response.data.result;
          that.extractDetailedFilterOptions(response.data.result);
        } else {
          that.$bvToast.toast(
            response.data.error || "Error fetching detailed history",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
          );
          that.detailedItems = [];
        }
      };

      let f = function(error) {
        console.log('Error fetching detailed data:', error);
        that.$bvToast.toast(
          "Error fetching detailed history",
          {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.detailedItems = [];
      };

      Requestor.getSyncP(path, data, this, s, f);
    },

    extractDetailedFilterOptions(detailedItems) {
      const locationsMap = new Map();

      detailedItems.forEach(item => {
        if (item.location_id && item.location_name) {
          locationsMap.set(item.location_id, {
            value: item.location_id,
            text: item.location_name
          });
        }
      });

      this.detailedLocationOptions = [
        { value: null, text: "ALL LOCATIONS" },
        ...Array.from(locationsMap.values())
      ];
    },

    clearDetailedFilters() {
      this.detailedDateRange = 'all_time';
      this.detailedLocationId = null;
    },

    toggleBestSellersFilterDropdown() {
      this.bestSellersFilterDropdownOpen = !this.bestSellersFilterDropdownOpen;
    },

    closeBestSellersFilterDropdown() {
      this.bestSellersFilterDropdownOpen = false;
    },

    fetchSoldDetails() {
      if (!this.selectedProduct) return;

      let that = this;
      let path = "/api/product/get_selling_history/";
      let data = {
        product_sku: this.selectedProduct.sku,
        view_type: 'sold_details'
      };

      let s = function(response) {
        if (response.data.result) {
          that.soldDetails = response.data.result;
          that.extractSoldDetailsFilterOptions(response.data.result);
        } else {
          that.$bvToast.toast(
            response.data.error || "Error fetching sold details",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
          );
          that.soldDetails = [];
        }
      };

      let f = function(error) {
        console.log('Error fetching sold details:', error);
        that.$bvToast.toast(
          "Error fetching sold details",
          {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.soldDetails = [];
      };

      Requestor.getSyncP(path, data, this, s, f);
    },

    extractSoldDetailsFilterOptions(soldDetails) {
      const locationsMap = new Map();
      const salespeopleMap = new Map();

      soldDetails.forEach(item => {
        // Locations
        if (item.store_location_id && item.store_location) {
          locationsMap.set(item.store_location_id, {
            value: item.store_location_id,
            text: item.store_location
          });
        } else if (item.store_location) {
          locationsMap.set(item.store_location, {
            value: item.store_location,
            text: item.store_location
          });
        }

        // Salespeople
        if (item.salesperson_id && item.salesperson_name) {
          salespeopleMap.set(item.salesperson_id, {
            value: item.salesperson_id,
            text: item.salesperson_name
          });
        } else if (item.salesperson_name) {
          salespeopleMap.set(item.salesperson_name, {
            value: item.salesperson_name,
            text: item.salesperson_name
          });
        }
      });

      this.soldLocationOptions = [
        { value: null, text: "ALL LOCATIONS" },
        ...Array.from(locationsMap.values())
      ];

      this.soldSalespersonOptions = [
        { value: null, text: "ALL SALESPERSONS" },
        ...Array.from(salespeopleMap.values())
      ];
    },

    applySoldDetailsFilters() {
      // Computed property will automatically update
    },

    clearSoldDetailsFilters() {
      this.soldDateRange = [];
      this.soldLocationFilter = null;
      this.soldSalespersonFilter = null;
      this.soldInvoiceFilter = '';
    },

    formatDate(dateString) {
      return moment(dateString).format('MMM DD, YYYY');
    },

    setBestSellersQuickDate(range) {
      let startDate, endDate;
      const today = moment();

      switch(range) {
        case '7_days':
          startDate = today.clone().subtract(7, 'days').format("MM-DD-YYYY");
          endDate = today.format("MM-DD-YYYY");
          break;
        case '30_days':
          startDate = today.clone().subtract(30, 'days').format("MM-DD-YYYY");
          endDate = today.format("MM-DD-YYYY");
          break;
        case '90_days':
          startDate = today.clone().subtract(90, 'days').format("MM-DD-YYYY");
          endDate = today.format("MM-DD-YYYY");
          break;
        default:
          startDate = today.clone().subtract(30, 'days').format("MM-DD-YYYY");
          endDate = today.format("MM-DD-YYYY");
      }

      this.bestSellersDateRange = [startDate, endDate];
      this.fetchBestSellersData();
    },

    clearBestSellersFilters() {
      this.bestSellersPickedLocation = null;
      this.bestSellersPickedUser = null;
      this.bestSellersDateRange = [moment().subtract(30, 'days').format("MM-DD-YYYY"), moment().format("MM-DD-YYYY")];
      this.bestSellersViewType = 'summary';
      this.selectedCategory = null; // Also clear category filter
      this.fetchBestSellersData();
    },

    calculateAverageProfitMargin(product) {
      // Your implementation for calculating profit margin
      return product.average_profit_margin || 0;
    },

    calculateTotalSellingPrice(product) {
      // Your implementation for calculating total selling price
      return product.total_revenue || 0;
    },

    async fetchBestSellersData() {
      this.bestSellersLoading = true;
      try {
        const data = {
          date_range: 'all_time',
          view_type: this.bestSellersViewType,
          location_id: this.bestSellersPickedLocation,
          username: this.bestSellersPickedUser,
          user_id: this.userDetails.id
        };

        if (this.bestSellersDateRange && this.bestSellersDateRange.length === 2) {
          data.start_date = this.bestSellersDateRange[0];
          data.end_date = this.bestSellersDateRange[1];
          data.date_range = 'custom';
        }

        if (this.$route.query.product_sku) {
          data.product_sku = this.$route.query.product_sku;
        }

        const response = await new Promise((resolve, reject) => {
          Requestor.postSyncP("/api/product/get_selling_history/", data, this,
            (response) => resolve(response),
            (error) => reject(error)
          );
        });

        if (response.data && response.data.result) {
          this.bestSellersData = response.data.result;
          this.extractCategories(); // Extract categories after data loads
          this.selectedCategory = null; // Reset category filter on new data load
        } else {
          this.bestSellersData = [];
          this.categoryOptions = [];
        }
      } catch (error) {
        console.error('Error fetching best sellers data:', error);
        this.bestSellersData = [];
        this.categoryOptions = [];
      } finally {
        this.bestSellersLoading = false;
      }
    }
  },
  mounted() {
    this.fetchBestSellersData();
    const grid = this.$refs.productsGrid;
    if (grid) {
      grid.addEventListener('scroll', this.updateScrollButtons);
      grid.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      grid.addEventListener('touchend', this.handleTouchEnd, { passive: true });

      this.$nextTick(() => {
        this.updateScrollButtons();
      });
    }
  },
  beforeDestroy() {
    const grid = this.$refs.productsGrid;
    if (grid) {
      grid.removeEventListener('scroll', this.updateScrollButtons);
      grid.removeEventListener('touchstart', this.handleTouchStart);
      grid.removeEventListener('touchend', this.handleTouchEnd);
    }
  }
}
</script>

<style scoped>
.glass2 {
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 30px 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

h4 {
  color: #2d3748;
  margin-bottom: 25px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Category Tabs Styles */
.category-tabs-section {
  overflow-x: auto;
  width:90%;
  margin-bottom: 0px;
   scrollbar-width: thin;
  scrollbar-color: rgba(0, 105, 139, 0.3) transparent;
}

.category-tabs-container {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 8px 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 105, 139, 0.3) transparent;
}

.category-tabs-container::-webkit-scrollbar {
  height: 6px;
}

.category-tabs-container::-webkit-scrollbar-track {
  background: rgba(0, 105, 139, 0.1);
  border-radius: 3px;
}

.category-tabs-container::-webkit-scrollbar-thumb {
  background: rgba(0, 105, 139, 0.3);
  border-radius: 3px;
}

.category-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  color: #2d3748;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  flex-shrink: 0;
}

.category-tab:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 105, 139, 0.3);
  transform: translateY(-2px);
}

.category-tab.active {
  background: #00698B;
  border-color: #00698B;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 105, 139, 0.3);
}

.tab-label {
  font-weight: inherit;
}

.tab-count {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 600;
}

.category-tab.active .tab-count {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* Summary Stats */
.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.9);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}



.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: #00698B;
}

.stat-header {
  margin-bottom: 15px;
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: white;
  margin: 0 auto;
}

.total-sales { background: linear-gradient(135deg, #dc3545, #c82333); }
.orders { background: linear-gradient(135deg, #28a745, #20c997); }
.average { background: linear-gradient(135deg, #ffc107, #fd7e14); }
.commission { background: linear-gradient(135deg, #17a2b8, #6f42c1); }
.refund { background: linear-gradient(135deg, #f56565, #e53e3e); }

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.95rem;
  color: #718096;
  font-weight: 500;
}

.stat-trend {
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.trend-positive {
  color: #48bb78;
}

.trend-negative {
  color: #f56565;
}

.stat-streak {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
}

/* Clickable Stat Styles */
.clickable-stat {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.clickable-stat:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.95);
}

.stat-hover-indicator {
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  background: rgba(66, 153, 225, 0.9);
  color: white;
  padding: 8px;
  text-align: center;
  font-size: 0.8rem;
  transition: bottom 0.3s ease;
  backdrop-filter: blur(5px);
  font-weight: 600;
}

.clickable-stat:hover .stat-hover-indicator {
  bottom: 0;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Chart Card */
.chart-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.enhanced-chart {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.chart-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 1);
}

.chart-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #42a4e1;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.chart-header h5 {
  margin: 0;
  color: #2d3748;
  font-weight: 700;
  font-size: 1.25rem;
}

.chart-title-section {
  width:10%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.scroll-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: #718096;
  background: rgba(0, 105, 139, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  animation: pulseHint 2s infinite;
}

@keyframes pulseHint {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

/* Horizontal Scroll Container */
.horizontal-scroll-container {
  position: relative;
  margin: 0 -15px;
  padding: 0 15px;
}

.scroll-buttons {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  pointer-events: none;
  z-index: 5;
}

.scroll-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid rgba(0, 105, 139, 0.3);
  color: #00698B;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  pointer-events: all;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(5px);
}

.scroll-btn:hover:not(:disabled) {
  background: #00698B;
  color: white;
  border-color: #00698B;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 105, 139, 0.3);
}

.scroll-btn:active {
  transform: scale(0.95);
}

.scroll-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  transform: none;
}

.scroll-btn:disabled:hover {
  background: rgba(255, 255, 255, 0.95);
  color: #00698B;
  border-color: rgba(0, 105, 139, 0.3);
}

.products-grid {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 15px 5px 25px 5px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 105, 139, 0.4) rgba(0, 105, 139, 0.1);
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  min-height: 280px;
}

/* Custom Scrollbar */
.products-grid::-webkit-scrollbar {
  height: 8px;
}

.products-grid::-webkit-scrollbar-track {
  background: rgba(0, 105, 139, 0.1);
  border-radius: 8px;
  margin: 0 5px;
}

.products-grid::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, rgba(0, 105, 139, 0.6), rgba(0, 105, 139, 0.8));
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.products-grid::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, rgba(0, 105, 139, 0.8), #00698B);
}

/* Product Card */
.product-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    padding: 16px;
    border: 1px solid rgba(226, 232, 240, 0.8);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    min-width: 280px;
    max-width: 300px;
    flex-shrink: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(5px);
    animation: fadeInUp 0.6s ease-out;
}
.product-card.featured-product .image-container {
    border: 2px solid #ffd700;
    box-shadow: 0 4px 20px rgba(255, 215, 0, 0.3);
}

/* Top product styling */
.product-card.top-product .image-container {
    border: 2px solid #42a4e1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .image-container {
        width: 100px;
        height: 80px;
    }
    
    .no-image-placeholder {
        width: 100px;
        height: 80px;
    }
    
    .product-card {
        min-width: 260px;
    }
}

@media (max-width: 480px) {
    .image-container {
        width: 90px;
        height: 70px;
    }
    
    .no-image-placeholder {
        width: 90px;
        height: 70px;
    }
    
    .product-card {
        min-width: 240px;
        padding: 12px;
    }
}

.product-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 1);
}

.product-card.featured-product {
  background: rgba(255, 249, 192, 0.95);
  border: 2px solid #ffd700;
  transform: scale(1.02);
}

/* Product Rank */
.product-rank {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.rank-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.rank-gold {
  background: linear-gradient(135deg, #ffd700, #ffed4e);
  color: #2d3748;
}
.rank-silver {
  background: linear-gradient(135deg, #c0c0c0, #e8e8e8);
  color: #2d3748;
}
.rank-bronze {
  background: linear-gradient(135deg, #cd7f32, #e89c5d);
  color: white;
}
.rank-other {
  background: linear-gradient(135deg, #718096, #a0aec0);
  color: white;
}

.product-trend {
  font-size: 0.75rem;
}

.trend-positive {
  color: #28a745;
}

.trend-negative {
  color: #dc3545;
}

.product-actions {
  display: flex;
  gap: 4px;
}

.product-image-section {
    margin-bottom: 12px;
    text-align: center;
}

.image-container {
    position: relative;
    display: inline-block;
    width: 270px;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgba(226, 232, 240, 0.8);
}

.image-container:hover {
    transform: scale(1.05);
    border-color: #42a4e1;
    box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3);
}

.product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.image-container:hover .product-image {
    transform: scale(1.1);
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    color: white;
    font-size: 1.5rem;
}

.image-container:hover .image-overlay {
    opacity: 1;
}

.no-image-placeholder {
    width: 270px;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed #cbd5e0;
    border-radius: 8px;
    background: rgba(247, 250, 252, 0.8);
    color: #a0aec0;
    transition: all 0.3s ease;
}

.no-image-placeholder:hover {
    border-color: #42a4e1;
    background: rgba(66, 153, 225, 0.05);
}

.placeholder-icon {
    font-size: 1.5rem;
    margin-bottom: 4px;
}

.placeholder-text {
    font-size: 0.75rem;
    font-weight: 600;
}

/* Product Info */
.product-info {
  /* margin-bottom: 12px; */
}

.product-name {
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 8px;
  font-size: 0.95rem;
  line-height: 1.4;
  /* min-height: 2.8em; */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-sku {
  margin-bottom: 6px;
}

.product-category {
  font-size: 0.75rem;
  color: #718096;
  font-style: italic;
}

/* Product Stats */
.product-stats {
  margin-bottom: 12px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(226, 232, 240, 0.5);
}

.stat-label {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 600;
}

.stat-value {
  font-weight: 800;
  color: #2d3748;
  font-size: 1.3rem;
}

.stat-breakdown {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #718096;
  background: rgba(0, 105, 139, 0.05);
  padding: 6px 10px;
  border-radius: 6px;
  margin-top: 6px;
}

.breakdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.breakdown-item strong {
  color: #2d3748;
  font-weight: 700;
  font-size: 0.85rem;
}

/* Profit Margin Styles */
.profit-high {
  color: #28a745;
  font-weight: bold;
}

.profit-medium {
  color: #ffc107;
  font-weight: bold;
}

.profit-low {
  color: #fd7e14;
  font-weight: bold;
}

.profit-negative {
  color: #dc3545;
  font-weight: bold;
}

/* Loading and Empty States */
.loading-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(5px);
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #dc3545;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-dashboard {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(5px);
}

.empty-dashboard .empty-icon {
  font-size: 4rem;
  color: #cbd5e0;
  margin-bottom: 20px;
}

.empty-dashboard h3 {
  color: #4a5568;
  margin-bottom: 12px;
  font-size: 1.5rem;
  font-weight: 600;
}

.empty-dashboard p {
  color: #718096;
  margin-bottom: 20px;
  font-size: 1rem;
}

/* Button Styles */
.btn {
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #42a4e1, #3182ce);
  border: none;
  box-shadow: 0 2px 10px rgba(66, 153, 225, 0.3);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(66, 153, 225, 0.4);
  background: linear-gradient(135deg, #3182ce, #2c5aa0);
}

.btn-outline-primary {
  border-color: #cbd5e0;
  color: #718096;
  background: rgba(255, 255, 255, 0.9);
}

.btn-outline-primary:hover {
  background-color: #f7fafc;
  border-color: #a0aec0;
  color: #4a5568;
  transform: translateY(-1px);
}

.btn-outline-secondary {
  border-color: #cbd5e0;
  color: #718096;
  background: rgba(255, 255, 255, 0.9);
}

.btn-outline-secondary:hover {
  background-color: #f7fafc;
  border-color: #a0aec0;
  color: #4a5568;
}

/* Modal Styles */
::v-deep .product-stats-modal .modal-content {
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 16px;
  color: #2d3748;
}

::v-deep .product-modal-header {
  background: rgba(66, 153, 225, 0.1);
  color: #2d3748;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 15px 15px 0 0;
  padding: 15px;
}

::v-deep .product-modal-body {
  padding: 0;
  background: transparent;
  border-radius: 0 0 15px 15px;
}

.product-stats-content {
  padding: 20px;
  background: rgba(255, 255, 255, 0.98);
}

/* Stats Grid for Modal */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.stats-grid .stat-card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: transform 0.2s ease;
}

.stats-grid .stat-card:hover {
  transform: translateY(-2px);
}

.stats-grid .stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 6px;
}

.stats-grid .stat-label {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 600;
}

/* Quick Actions */
.quick-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

/* Table Styles */
.table-scroll-container {
  overflow-x: auto;
  max-height: 400px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.detailed-table,
.sold-details-table,
.salesperson-table {
  min-width: 800px;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  font-size: 11px !important;
}

/* Table cell styles */
.table-cell {
  font-size: 11px !important;
  padding: 4px 6px !important;
}

.header-row {
  font-weight: 600;
  font-size: 11px !important;
  color: #2d3748;
  background: rgba(66, 153, 225, 0.15);
}

/* Make badges and buttons smaller in tables */
.detailed-table .badge,
.sold-details-table .badge {
  font-size: 10px !important;
  padding: 2px 6px !important;
}

.detailed-table .btn,
.sold-details-table .btn {
  font-size: 10px !important;
  padding: 2px 6px !important;
}

/* Location link styling */
.location-link {
  color: #42a4e1 !important;
  text-decoration: none !important;
  font-weight: 600;
}

.location-link:hover {
  color: #3182ce !important;
  text-decoration: underline !important;
}

.invoice-link {
  color: #42a4e1 !important;
  text-decoration: none !important;
  font-weight: 600;
  font-size: 10px !important;
}

.invoice-link:hover {
  color: #3182ce !important;
  text-decoration: underline !important;
}

/* Salesperson Modal */
::v-deep .salesperson-modal .modal-content {
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 16px;
}

::v-deep .salesperson-modal-header {
  background: rgba(66, 153, 225, 0.1);
  color: #2d3748;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 15px 15px 0 0;
  padding: 15px;
}

::v-deep .salesperson-modal-body {
  padding: 20px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 0 0 15px 15px;
}

.salesperson-content {
  background: rgba(255, 255, 255, 0.98);
}

/* Top Seller Modal */
::v-deep .top-seller-modal .modal-content {
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 16px;
}

.top-seller-content {
  padding: 20px;
  text-align: center;
}

.top-seller-header {
  margin-bottom: 20px;
}

.crown-icon {
  font-size: 3rem;
  color: #ffd700;
  margin-bottom: 10px;
}

.performance-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.performance-metric {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 5px;
}

.metric-label {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 600;
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .summary-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .glass2 {
    padding: 20px;
  }

  .summary-stats {
    grid-template-columns: 1fr 1fr;
  }

  .category-tabs-container {
    gap: 6px;
    padding: 6px 0;
  }

  .category-tab {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .tab-count {
    padding: 1px 6px;
    font-size: 0.7rem;
  }

  .scroll-buttons {
    display: none;
  }

  .products-grid {
    scroll-snap-type: x mandatory;
    padding: 10px 5px 20px 5px;
  }

  .product-card {
    scroll-snap-align: start;
    min-width: 280px;
  }

  .quick-actions {
    flex-direction: column;
    align-items: center;
  }

  .modal-actions {
    flex-direction: column;
    align-items: center;
  }

  .performance-stats {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .glass2 {
    padding: 15px 10px;
    border-radius: 12px;
  }

  .stat-card {
    padding: 15px;
    border-radius: 12px;
  }

  .product-card {
    min-width: 240px;
    padding: 12px;
  }

  .category-tab {
    padding: 6px 10px;
    font-size: 0.75rem;
  }

  .summary-stats {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 769px) {
  .chart-header {
    flex-wrap: wrap;
  }
  .chart-title-section {
    width: auto;
  }

  .category-tabs-section {
    width: auto;
  }
}

/* Tablet and Desktop */
@media (min-width: 769px) {
  .summary-stats {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;
  }

  .scroll-buttons {
    display: flex;
  }
}

/* Large Desktop Styles */
@media (min-width: 1024px) {
  .glass2 {
    padding: 50px 40px;
  }

  .summary-stats {
    gap: 25px;
  }

  .stat-card {
    padding: 30px;
  }

  .products-grid {
    gap: 25px;
    padding: 25px 15px 35px 15px;
  }

  .product-card {
    min-width: 320px;
    max-width: 350px;
  }
}

/* High DPI Screen Optimization */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .glass2 {
    backdrop-filter: blur(10px);
  }

  .stat-card,
  .chart-card {
    backdrop-filter: blur(8px);
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .stat-card,
  .chart-card,
  .btn,
  .product-card,
  .category-tab {
    transition: none;
  }

  .pulse {
    animation: none;
  }

  .spinner {
    animation-duration: 2s;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Homepagecomponents/BestSellersDashboard.vue